import { QueryClient } from '@tanstack/react-query';
import axios from 'axios';

export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 10 * 60_000,
        retry: (failureCount, error) => {
          const status = axios.isAxiosError(error)
            ? error.response?.status
            : undefined;
          return status !== 401 && status !== 403 && failureCount < 2;
        },
        // TanStack's boolean defaults are stale-aware. Forcing "always" here
        // made the freshly cached login session refetch immediately, so a
        // transient profile failure could bounce forever between / and /login.
        refetchOnMount: true,
        refetchOnReconnect: true,
        refetchOnWindowFocus: true,
      },
      mutations: { retry: false },
    },
  });
}
